export default Object.freeze({
  DenyOverrides: 1,
  AllowOverrides: 2,
  FirstMatch: 3,
});
